import React, { useEffect, useState } from "react";
import SeasonsList from "./SeasonsList";
import InlineLoader from "../../../../../common/InlineLoader";

const StatsTeamList = (props) => {
  const [positionList, setPositionList] = useState([]);
  const [teamList, setTeamList] = useState([]);
  useEffect(() => {
    if (
      props.primaryPositionList &&
      props.primaryPositionList.data &&
      props.primaryPositionList.data.length
    ) {
      setPositionList(props.primaryPositionList.data);
    }
  }, [props.primaryPositionList]);
  
  useEffect(() => {
    if (
      props.teamList &&
      props.teamList.data &&
      props.teamList.data.allTeamsList &&
      props.teamList.data.allTeamsList.length
    ) {
      setTeamList(props.teamList.data.allTeamsList);
    }
  }, [props.teamList]);
  const getEditVal = (id) => {
    return props.isEdit ? (id === props.savedId ? true : false) : false;
  };
  return (
    <>
      <InlineLoader open={!(props.teamData.length && teamList.length)} />
      {!!(props.teamData.length && teamList.length) &&
        props.teamData.map((item, i) => {
          const position = positionList.filter((position) => {
            return position.id == item.positionid;
          });
          const teamName = teamList.filter((team) => {
            return team.id == item.teamid;
          });
          return (
            <div key={item.id}>
              <div className="position-catcher-flex">
                <div className="champions-title">
                  <h5>Team :{" "}
                    {teamName.length ? teamName[0].teamname : "Team"}</h5>
                </div>
                <div className="button-box">
                  <button className="btn outlined green medium">
                    Position : {" "}
                    {position.length && position[0].shortform}
                  </button>
                </div>
              </div>

              <SeasonsList
                key={item.id}
                id={item.id}
                season={item}
                team={teamName}
                position={position}
                savedId={props.savedId}
                onCancel={props.onCancel}
                onSaveFields={props.onSaveFields}
                deleteSaveFields={props.deleteSaveFields}
                {...props}
                isEdit={getEditVal(item.id)}
              />
            </div>
          );
        })}
    </>
  );
};

export default StatsTeamList;
